// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__Hx4AV","tag":"Tag_tag__A2jv3","pointer":"Tag_pointer__s9tRj"};